module.exports = ".header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 50px; }\n  .header h1 {\n    margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/client/list/list.component.scss
// module id = ./src/app/modules/client/list/list.component.scss
// module chunks = main